import React, { useEffect } from "react";
import TechBridgeCount from "./TechBridgeCount";
import ChartBox from "../component/ChartBox";
import { Col, Row } from "react-bootstrap";
import { CompareChart } from "../component/CompareChart";
import Chart from "../component/Chart";
import {
  useGetDashboardTotalCountQuery,
  useGetDashboardTotalleadQuery,
  useGetWellnesschartQuery,
} from "../../../../Service/dashboard";
import { dashboard, ivfdashboard } from "../Utils/TableHeadlist";
import { useDispatch, useSelector } from "react-redux";
import { Reset } from "../../../../store/async-actions/digitalmarketing/header";
import WellnessChart from "../component/WellnessChart";

function TechBridge() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Reset());
  }, []);
  const account = useSelector((state: any) => state.auth);

  const { data } = useGetDashboardTotalCountQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const { data: dashboardLeadData }: any = useGetDashboardTotalleadQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const { data: dashboardWellnessChart }: any = useGetWellnesschartQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  // console.log(dashboardWellnessChart);
  
  let dashboardCountList = [];
  // console.log(dashboardLeadData?.sourceData);

  if (data) {
    const totalCountValue = Object.values(data);
    if(account.permissions.ivf_journey_status===1){
      dashboardCountList = ivfdashboard.map((item, index) => {
        item.list = data?.[item.name];
        return item;
      });
    }
    else {
    dashboardCountList = dashboard.map((item, index) => {
      item.list = data?.[item.name];
      return item;
    });
  }
  }
  return (
    <>
      <h3 className="f-20 fw-600">Mimo Konnect</h3>
      <TechBridgeCount CountList={dashboardCountList} />
      <Row className="mt-3 mb-3">
        <Col className="mb-3" md={12} lg={6}>
        <ChartBox
            element={<Chart list={dashboardLeadData?.TotalLeadBasedCount} />}
            prevMonth={dashboardLeadData?.preMonthTotal}
            thisMonth={dashboardLeadData?.thisMonthTotal}
            title="Total lead count comparison"
            legend={true}
          />
        </Col>
        <Col className="mb-3" md={12} lg={6}>
          <ChartBox
            element={<CompareChart list={dashboardLeadData?.sourceData} />}
            prevMonth={dashboardLeadData?.preSourceTotal}
            thisMonth={dashboardLeadData?.thisSourceTotal}
            title="Source based lead count comparison"
            legend={false}
          />
         
        </Col>
        
        {/* <Col className="mb-3" md={12} lg={6}>
          <ChartBox
            element={<Chart list={dashboardLeadData?.city_list} />}
            prevMonth={dashboardLeadData?.preCityTotal}
            thisMonth={dashboardLeadData?.thisCityTotal}
            title="City based lead count comparison"
            legend={true}
          />
        </Col>
        <Col className="mb-3" md={12} lg={6}>
          <ChartBox
            element={<Chart list={dashboardLeadData?.service_list} />}
            prevMonth={dashboardLeadData?.preServiceTotal}
            thisMonth={dashboardLeadData?.thisServiceTotal}
            title="Total lead count comparison"
            legend={true}
          />
        </Col> */}
      </Row>
      <Row className="mt-3 mb-3">
        <Col className="mb-3" md={12} lg={12}>
        <ChartBox
            element={<WellnessChart list={dashboardWellnessChart?.data}              title="Wellness category count comparison"
            />}
          
          />
        </Col>
        </Row>
    </>
  );
}

export default TechBridge;